import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ReferralLinks from '@/components/v2/ReferralLinks.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ReferralLinkForm from '@/components/v2/ReferralLinkForm.vue';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import ReferralLinkExport from '@/components/v2/ReferralLinkExport.vue';
import LinkButton from '@/components/link_button/Index.vue';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let NotificationsManager = class NotificationsManager extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, CleverTapEventsMixin) {
    notificationTabs() {
        const commonProps = {
            flat: true,
            capitalized: true,
            navigator: true,
            exact: true,
            orangeTheme: true,
            class: 'notification-tab',
        };
        const { parentMenu } = this.$route.meta;
        return [
            {
                ...commonProps,
                path: { name: `${parentMenu}-manager-email` },
                label: 'Email Notification',
            },
            {
                ...commonProps,
                path: { name: `${parentMenu}-manager-fb-messenger` },
                label: 'In-App Store Notification',
            },
        ];
    }
    mounted() {
        this.viewNotificationManagerPage();
    }
};
NotificationsManager = __decorate([
    Component({
        components: {
            PageTitle,
            ReferralLinks,
            ActionButton,
            ReferralLinkForm,
            AppBasicDetails,
            ReferralLinkExport,
            LinkButton,
        },
    })
], NotificationsManager);
export default NotificationsManager;
